import React from 'react'

export default class ActionsWidget extends React.Component {
  state = {
    disabled: false,
  }

  onClick(e) {
    e.preventDefault()

    if (!this.state.disabled) {
      this.setState({ disabled: true })
    }

    this.props.deleteFavorite(this.props.id, (result) => {
      if (result) { this.props.refreshParent() }
    })
  }

  render() {
    return (
      <div>
        <button className="form-control button btn-danger" onClick={this.onClick.bind(this)}>
          { this.props.children ? this.props.children : 'Supprimer'}
        </button>
      </div>
    )
  }
}
